import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {MobilePhoneRegularIcon} from 'shells/icon/svg/mobile-phone-regular-icon';
// @ts-expect-error - imported from .js/.jsx file
import {QRCodeIcon} from 'shells/icon/svg/qr-code-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import {getMfa} from '../../../auth/utils';

import {TYPE_APP, TYPE_SMS} from '../constants';
import type {Method, GetMfaApiResponse} from '../types';

import styles from './select-method-screen.module.css';

type Props = {
    setSelectedMfaMethod: (arg1: Method) => void;
    selectedMfaMethod: Method;
};

export function SelectMethodScreen(props: Props) {
    const [enabledMfaMethod, setMfaMethod] = React.useState<any>(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const {selectedMfaMethod, setSelectedMfaMethod} = props;

    React.useEffect(() => {
        getMfa().then((result: GetMfaApiResponse) => {
            if (result.result && result.result.type !== null) {
                setMfaMethod(result.result.type);
            }
            setIsLoading(false);
        });
    }, [setSelectedMfaMethod, setIsLoading]);

    if (isLoading) {
        return null;
    }

    return (
        <StackLegacy spacing={16} isHorizontal={false}>
            <TwoLineButtonCard
                onClick={() => setSelectedMfaMethod('sms')}
                isSelected={selectedMfaMethod === 'sms'}
            >
                <TwoLine
                    icon={MobilePhoneRegularIcon}
                    iconSize={24}
                    iconColor={colors.greyDk}
                    topRow={enabledMfaMethod === TYPE_SMS ? 'New SMS number' : 'SMS'}
                    bottomRow={
                        enabledMfaMethod === TYPE_SMS
                            ? 'Use a different phone number to generate log in codes'
                            : 'We’ll text you a code to enter at log in'
                    }
                    isLargeWithSmallBottomRow={true}
                    shouldCenterSingleLine={true}
                />
            </TwoLineButtonCard>
            <TwoLineButtonCard
                onClick={() => props.setSelectedMfaMethod('app')}
                isSelected={props.selectedMfaMethod === 'app'}
            >
                <TwoLine
                    icon={QRCodeIcon}
                    iconSize={24}
                    iconColor={colors.greyDk}
                    topRow={
                        enabledMfaMethod === TYPE_APP
                            ? 'New authenticator app'
                            : 'Authenticator app'
                    }
                    bottomRow={
                        enabledMfaMethod === TYPE_APP
                            ? 'Use a different app to generate log in codes'
                            : 'Use an app to generate a code to enter at log in'
                    }
                    isLargeWithSmallBottomRow={true}
                    shouldCenterSingleLine={true}
                />
            </TwoLineButtonCard>
            {/* If an MFA method is already enabled, show it as a disabled option. */}
            {enabledMfaMethod !== null ? (
                <TwoLineButtonCard
                    onClick={() => props.setSelectedMfaMethod('app')}
                    isSelected={props.selectedMfaMethod === 'app'}
                    isDisabled={true}
                    // @ts-expect-error
                    disabled={true}
                >
                    <TwoLine
                        icon={enabledMfaMethod === TYPE_SMS ? MobilePhoneRegularIcon : QRCodeIcon}
                        iconSize={24}
                        iconColor={colors.greyDk}
                        topRow={enabledMfaMethod === TYPE_SMS ? 'SMS' : 'Authenticator app'}
                        bottomRow={<span className={styles.success}>Current method</span>}
                        isLargeWithSmallBottomRow={true}
                        shouldCenterSingleLine={true}
                    />
                </TwoLineButtonCard>
            ) : undefined}
        </StackLegacy>
    );
}
